import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Box, Flex, Text, Link } from "@chakra-ui/react";
import { LabTest } from "sdk/labTests";
import { Check } from "~/icons";

interface Props {
  labTest: LabTest;
  userName: string;
}

export const ToDoCard: FC<Props> = ({ labTest, userName }) => {
  const { t } = useTranslation();

  const isCompleted = labTest.status === "completed";

  const status = isCompleted ? "completed" : "pending";

  return (
    <Box
      bg="th.white"
      borderRadius="lg"
      boxShadow="0px 5px 19px 0px rgba(0, 0, 0, 0.05)"
      p={4}
      px={6}
    >
      <Flex
        direction={{ base: "column", md: "row" }}
        justify="space-between"
        align="start"
        gap={6}
      >
        <Flex direction="column" gap={1}>
          {isCompleted && (
            <Box
              bg="th.yellowGreen1"
              px={4}
              py={1}
              display="inline-flex"
              alignItems="center"
              gap={1}
              mb={2}
              width="fit-content"
              sx={{
                clipPath:
                  "polygon(12px 0, 100% 0, calc(100% - 12px) 100%, 0 100%)",
              }}
            >
              <Check boxSize={3.5} color="th.black" />
              <Text
                fontSize="12px"
                fontWeight="medium"
                color="th.black"
                textTransform="uppercase"
                letterSpacing="0.5px"
                lineHeight="1.2"
                whiteSpace="nowrap"
              >
                {t(`diagnosticDashboard.labTest.status.${status}`)}
              </Text>
            </Box>
          )}
          <Box>
            <Text
              fontSize="18px"
              fontWeight="bold"
              color="th.black"
              lineHeight="1.4"
            >
              {t(`diagnosticDashboard.labTest.statusMessage.${status}`)}
            </Text>
            <Text fontSize="18px" color="th.black" lineHeight="1.4">
              {labTest.name}
            </Text>
            <Text fontSize="18px" color="th.gray4" lineHeight="1.4">
              for {userName}
            </Text>
          </Box>
        </Flex>
        {isCompleted && (
          <Flex
            justify="center"
            align="center"
            height="full"
            alignSelf={{ base: "start", md: "center" }}
          >
            <Link
              href={labTest.result_download_url || "#"}
              target={labTest.result_download_url ? "_blank" : "_self"}
              rel={labTest.result_download_url ? "noopener noreferrer" : ""}
              color="th.signatureGreen"
              fontSize="16px"
              fontWeight="bold"
              textDecoration="none"
              _hover={{ textDecoration: "underline" }}
              whiteSpace="nowrap"
              lineHeight="1.4"
            >
              View results
            </Link>
          </Flex>
        )}
      </Flex>
    </Box>
  );
};
